import axios from 'axios'
import { DEMANDBASE_COUNTRY_MAP } from '../mappings/FIELD_CONSTANTS'

export default class DemandBase{

    /**
     *
     * @param data
     * @param forceUpdate
     */
    constructor(data, forceUpdate, settings) {
        this.settings = settings
        this.data = data
        this.forceUpdate = forceUpdate
        this.vars = {
            key : '4b12dbd75ae1a3f83bf93de077c47d8e4a11bca8',
            user_pick : false,
            widget_match : false,
            ip_match : false,
            domain_match : false,
            prev_source : false,
            contact_change : false,
            phone_change : false,
            db_ip_api_url : "//api.demandbase.com/api/v2/ip.json?key=",
            db_domain_api_url: "//api.demandbase.com/api/v1/domain.json?key="
        }
        this.returnData = {
            ip_data : {},
            domain_data : {},
            widget_data : {},
            dbase_data : {}
        }
        this.fieldMap = {
            "address" : "street_address",
            "city" : "city",
            "state" : "state",
            "postalCode" : "zip",
            "country" : "country",
            "phone" : "phone",
            "Demandbase_Id__c" : "demandbase_sid",
            "Demandbase_Phone__c" : "phone",
            "Demandbase_Industry__c" : "industry",
            "Demandbase_Sub_Industry__c" : "sub_industry",
            "Demandbase_Employee_Range__c" : "employee_range",
            "Demandbase_Employee_Count__c" : "employee_count",
            "dbase_duns_number" : "duns_num",
            "Demandbase_Marketing_Alias__c" : "marketing_alias",
            "Demandbase_Country__c" : "country",
            "Demandbase_Annual_Sales__c" : "annual_sales",
            "Demandbase_Company_Name__c" : "company_name",
            "Demandbase_City__c" : "city",
            "Demandbase_Country_Code__c" : "country_name",
            "Demandbase_SIC__c" : "primary_sic",
            "Demandbase_State__c" : "state",
            "Demandbase_Street_Address__c" : "street_address",
            "Demandbase_URL__c" : "web_site",
            "Demandbase_Zip__c" : "zip",
            "Demandbase_Company_Domestic_HQ__c" : "dbase_company_domestic_hq", //we will overwrite this but it will at least default
            "Demandbase_Company_HQ__c" : "dbase_company_hq", //we will overwrite this but it will at least default
            "Demandbase_Company_World_HQ__c" : "dbase_company_world_hq", //we will overwrite this but it will at least default
            "dbase_duns_number_domestic_hq" : "dbase_duns_number_domestic_hq", //we will overwrite this but it will at least default
            "dbase_duns_number_hq" : "dbase_duns_number_hq", //we will overwrite this but it will at least default
            "dbase_duns_number_world_hq" : "dbase_duns_number_world_hq"//we will overwrite this but it will at least default
        }
        this._init()
    }

    /**
     * Updates a value
     * @param prop
     * @param val
     */
    updateValue(prop, val){
        this.vars[prop] = val
    }

    /**
     * Create the demandbase script/css references and add them to the DOM, init the widget
     * @private
     */
    _loadDemandBase(){

        if(this.settings.demandbaseWidgetEnabled) {
            let self = this
            let demandBaseAutoCompleteJS = document.createElement('script')
            demandBaseAutoCompleteJS.setAttribute('src', '//api.demandbase.com/autocomplete/widget.js')
            document.head.appendChild(demandBaseAutoCompleteJS)

            let demandBaseAutoCompleteCSS = document.createElement('link')
            demandBaseAutoCompleteCSS.setAttribute('type', 'text/css')
            demandBaseAutoCompleteCSS.setAttribute('rel', 'stylesheet')
            demandBaseAutoCompleteCSS.setAttribute('href', 'https://autocomplete.demandbase.com/autocomplete/stylesheet.v2.css')
            document.head.appendChild(demandBaseAutoCompleteCSS)

            window.setTimeout(function (e) {
                window.Demandbase.CompanyAutocomplete.widget({
                    company: "Company_Self_Reported__c",  // attach autocomplete to input field with id = company
                    email: "Email",             // attach autocomplete to input field with id = email
                    key: self.vars.key,     // add your Demandbase Forms key here
                    callback: function (data) {
                        self._DemandBaseAutoCompleteWidget(data)
                    }
                })
                self._initSelf()
            }, 1500)
        }else{
            this._initSelf()
        }
    }

    /**
     *
     * @private
     */
    _runDomainCheckIfEmailNotEmpty(){
        if(this.data.fields.email !== ""){
            this.DemandbaseDomainQuery(this.data.fields.email)
        }
    }

    /**
     *
     * @private
     */
    _initSelf(){
        if(this.data.status.prefilled){
            if(this.data.prefillData["Demandbase_Enhanced__c"] !== 'true'){
                this.data.fields.Demandbase_Datasource__c = "User_Source"
                this.DemandbaseIPQuery() //run ip api to see if we can get a hit
                this._runDomainCheckIfEmailNotEmpty()
            }else if(this.data.prefillData["Demandbase_Enhanced__c"] === 'true'){
                switch (this.data.prefillData["Demandbase_Datasource__c"]) {
                    case 'IP_API': //ip then run email to see if we can elevate
                        this.prev_source = true
                        this.DemandbaseIPQuery()
                        this._runDomainCheckIfEmailNotEmpty()
                        break
                    case 'Domain_API':
                        this.prev_source = true
                        this._runDomainCheckIfEmailNotEmpty()
                        break
                    case 'User_Source':
                        this.DemandbaseIPQuery()
                        this._runDomainCheckIfEmailNotEmpty()
                        break
                    case 'Company_Widget':
                        this.prev_source = true
                        break //do nothing
                    default:
                        this.DemandbaseIPQuery()
                        this._runDomainCheckIfEmailNotEmpty()
                        break
                }
            }else{
                this.data.prefillData["Demandbase_Datasource__c"] = "User_Source"
            }

        }else{
            //not a cookied user
            this.DemandbaseIPQuery()
        }

        //TODO: hooks for input changes on country, email and phone
        // see: view-source:https://deliver.citrix.com/rs/citrixsandbox4/images/mktoFunctionsOptimized.js

        this.forceUpdate()
    }

    /**
     *
     * @param data
     * @private
     */
    _DemandBaseAutoCompleteWidget(data){
        if(this.data.fields.Company_Self_Reported__c !== ""){
            if(data.pick){
                this.vars.widget_match = true
                if (data.pick.company_name !== null || data.pick.company_name !== "") {
                    this.returnData.widget_data = data.pick
                    this.vars.widget_match = true

                    //custom worldhq mappings
                    this.returnData.widget_data.employee_range = data.pick.worldhq.employee_range
                    this.returnData.widget_data.employee_count = data.pick.worldhq.employee_count
                    this.returnData.widget_data.employee_num = data.pick.worldhq.employee_range

                    this.returnData.widget_data.dbase_company_world_hq = data.pick.worldhq.company_name
                    this.returnData.widget_data.dbase_duns_number_world_hq = data.pick.worldhq.duns_num

                    //custom domestichq mappings
                    this.returnData.widget_data.dbase_company_domestic_hq = data.pick.domestichq.company_name
                    this.returnData.widget_data.dbase_duns_number_domestic_hq = data.pick.domestichq.duns_num

                    //custom hq mappings
                    this.returnData.widget_data.dbase_company_hq = data.pick.hq.company_name
                    this.returnData.widget_data.dbase_duns_number_hq = data.pick.hq.duns_num
                }else{
                    this.vars.widget_match = false
                }
                this._dbFormData()
            }
        }
    }

    /**
     *
     * @constructor
     */
    DemandbaseIPQuery(){
        let self = this
        // you can test this script by passing an ip in the url
        let ip_test = this._getUrlParameter("ip")
        let dburl = (ip_test === "") ? this.vars.db_ip_api_url + this.vars.key : this.vars.db_ip_api_url + this.vars.key + "&query=" + ip_test

        axios({
            method: 'get',
            url: dburl
        }).then(function (response) {
            let data = response.data
            self.returnData.dbase_data.dbase_ip_address = data.ip
            self.returnData.dbase_data.dbase_information_level = data.information_level

            if (!data.isp && data.information_level !== "Basic") {
                self.returnData.ip_data = data.hq
                self.vars.ip_match = true

                //custom worldhq mappings
                self.returnData.ip_data.employee_range = data.worldhq.employee_range
                self.returnData.ip_data.employee_count = data.worldhq.employee_count
                self.returnData.ip_data.employee_num = data.worldhq.employee_range

                self.returnData.ip_data.dbase_company_world_hq = data.worldhq.company_name
                self.returnData.ip_data.dbase_duns_number_world_hq = data.worldhq.duns_num

                //custom domestichq mappings
                self.returnData.ip_data.dbase_company_domestic_hq = data.domestichq.company_name
                self.returnData.ip_data.dbase_duns_number_domestic_hq = data.domestichq.duns_num

                //custom hq mappings
                self.returnData.ip_data.dbase_company_hq = data.hq.company_name
                self.returnData.ip_data.dbase_duns_number_hq = data.hq.duns_num
            }else{
                self.vars.ip_match = false
            }
            self.data.fields.clientIPAddress = data.ip
            self.forceUpdate()

        }).catch(function(e){

        })

    }

    /**
     * Perform domain query with email and update values
     * @param email
     * @constructor
     */
    DemandbaseDomainQuery(email){

        if(window.Demandbase === undefined) {
            return
        }

        let self = this
        let domain = email.split('@')
        let dburl = this.vars.db_domain_api_url + this.vars.key + "&query=" + domain[1]

        axios({
            method: 'get',
            url: dburl
        }).then(function (response) {
            //console.log(response.data.domain)
            if(response.data.domain !== null){
                let data = response.data
                self.returnData.domain_data = data.domain
                self.vars.domain_match = true
                self.returnData.dbase_data.dbase_domain_match = "yes" //indicate that we were able to make a match

                //custom worldhq mappings
                self.returnData.domain_data.employee_range = data.domain.worldhq.employee_range
                self.returnData.domain_data.employee_count = data.domain.worldhq.employee_count
                self.returnData.domain_data.employee_num = data.domain.worldhq.employee_range

                self.returnData.domain_data.dbase_company_world_hq = data.domain.worldhq.company_name
                self.returnData.domain_data.dbase_duns_number_world_hq = data.domain.worldhq.duns_num

                //custom domestichq mappings
                self.returnData.domain_data.dbase_company_domestic_hq = data.domain.domestichq.company_name
                self.returnData.domain_data.dbase_duns_number_domestic_hq = data.domain.domestichq.duns_num

                //custom hq mappings
                self.returnData.domain_data.dbase_company_hq = data.domain.hq.company_name
                self.returnData.domain_data.dbase_duns_number_hq = data.domain.hq.duns_num
            }else{
                if((self.data.prefillData["Demandbase_Datasource__c"] === "Domain_API" && !self.vars.widget_match) || (self.returnData.dbase_data.dbase_domain_match === "yes" && !self.vars.widget_match)){
                    self._clearDbaseFields()
                    self.DemandbaseIPQuery() //retry ip api for a hit since we didnt run before

                    self.returnData.dbase_domain_match = "no" //indicate that we were not able to make a match
                    self.vars.domain_match = false
                }
            }

            self._dbFormData()

        }).catch(function(e){
            console.log('___ERROR____')
            console.log(e)
            console.log("___________")
        })

    }

    /**
     *
     * @param data
     * @private
     */
    _fillDbaseFields(data){
        if(data) {
            for (let item in this.fieldMap) {
                    switch(item){
                        case 'country':
                            if(!this.vars.contact_change) {
                                this.data.fields[item] = DEMANDBASE_COUNTRY_MAP[data[this.fieldMap[item]]]
                            }
                            break
                        case 'state':
                            if(!this.vars.contact_change) {
                                this.data.fields[item] = data[this.fieldMap[item]]
                            }
                            break
                        case 'city':
                            if(!this.vars.contact_change) {
                                this.data.fields[item] = data[this.fieldMap[item]]
                            }
                            break
                        case 'phone':
                            if(!this.vars.phone_change) {
                                this.data.fields[item] = data[this.fieldMap[item]]
                            }
                            break
                        case 'address':
                            if(!this.vars.contact_change) {
                                let address = data[this.fieldMap[item]]
                                this.data.fields[item] = (address.length < 40) ? address : (address.substring(0, 36) + "...")
                            }
                            break
                        default:
                            this.data.fields[item] = data[this.fieldMap[item]]
                    }
            }

            this.forceUpdate()
        }

    }

    /**
     *
     * @private
     */
    _dbFormData(){
        if (this.vars.widget_match) {
            this._fillDbaseFields(this.returnData.widget_data)
            this.data.fields.Demandbase_Datasource__c = "Company_Widget"
            this.data.fields.Demandbase_Enhanced__c = "true"
        }else if(this.vars.domain_match){
            this._fillDbaseFields(this.returnData.domain_data)
            this.data.fields.Demandbase_Datasource__c = "Domain_API"
            this.data.fields.Demandbase_Enhanced__c = "true"
        }else if(this.vars.ip_match){
            this._fillDbaseFields(this.returnData.ip_data)
            this.data.fields.Demandbase_Datasource__c = "IP_API"
            this.data.fields.Demandbase_Enhanced__c = "true"
        }else{
            this.data.fields.Demandbase_Enhanced__c = "false"
            if(!this.vars.prev_source){
                this.data.fields.Demandbase_Datasource__c = "User_Source"
            }
            for(let item in this.returnData.dbase_data){
                this.data.fields[item] = this.returnData.dbase_data[item]
            }
        }

        this.forceUpdate()
    }

    /**
     *
     * @private
     */
    _clearDbaseFields(){
        for(let item in this.fieldMap){
            this.data.fields[item] = ""
        }

        //clear out our custom mappings
        this.data.fields.Demandbase_Datasource__c = ""
        this.data.fields.phone = ""
        this.data.fields.Demandbase_Datasource__c = ""
        this.data.fields.Demandbase_Enhanced__c = ""

        this.forceUpdate()
    }

    /**
     *
     * @param name
     * @returns {string}
     * @private
     */
    _getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
        let results = regex.exec(location.search)
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }

    /**
     * Load Demandbase
     * @private
     */
    _init(){
        if(window.Demandbase !== undefined) {
            this._loadDemandBase()
        }
    }

}
